import axios from 'axios';
import Constants from '../constants';
import { ISurveyTermEditModel } from '../models/ISurveyTermEditModel';
import { ISurveyTermItemEditModel, ISurveyTermItemAddModel } from '../models/ISurveyTermItemEditModel';

export async function FetchSurveyTerm(surveyId: number, cultureCode: string): Promise<ISurveyTermEditModel> {
	const res = await axios.get(`${Constants.API_SURVEY_TERMS_URL.replace('{surveyId}', surveyId.toString())}?cultureCode=${cultureCode}`);
	return res.data;
}

export async function FetchSurveyTermItems(surveyId: number, cultureCode: string): Promise<ISurveyTermItemEditModel[]> {
	const res = await axios.get(
		`${Constants.API_SURVEY_TERM_ITEMS_URL.replace('{surveyId}', surveyId.toString())}?cultureCode=${cultureCode}`,
	);
	return res.data;
}

export async function AddSurveyTermItem(newSurveyTermItem: ISurveyTermItemAddModel): Promise<ISurveyTermItemEditModel> {
	const res = await axios.post(
		`${Constants.API_SURVEY_TERM_ITEMS_URL.replace('{surveyId}', newSurveyTermItem.surveyId.toString())}`,
		newSurveyTermItem,
	);
	return res.data;
}

export async function RemoveSurveyTermItem(surveyId: number, surveyTermItemId: number): Promise<ISurveyTermItemEditModel> {
	const res = await axios.delete(`${Constants.API_SURVEY_TERM_ITEMS_URL.replace('{surveyId}', surveyId.toString())}/${surveyTermItemId}`);
	return res.data;
}

export async function UpdateSurveyTerm(surveyId: number, surveyTermAdminEdit: ISurveyTermEditModel): Promise<ISurveyTermEditModel> {
	const res = await axios.put<ISurveyTermEditModel>(`${Constants.API_URL}/surveys/${surveyId}/survey-terms`, surveyTermAdminEdit);
	return res.data;
}
